import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../authentication.service';
import { WarningPanelComponent } from '../../comps/warning-panel/warning-panel.component';
import { SimpleProgressComponent } from '../../comps/simpleprogress.component';
import { BGAnimationComponent } from '../../comps/bganimation/bganimation.component';
import { AuthShellComponent } from '../auth-shell/auth-shell.component';
import { MaterialModule } from '../../material.module';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-confirm',
    templateUrl: './confirm.component.html',
  imports: [MaterialModule, BGAnimationComponent, AuthShellComponent, FormsModule, ReactiveFormsModule, SimpleProgressComponent, WarningPanelComponent]
})
export class ConfirmComponent implements OnInit {

  environment = environment;

  form: UntypedFormGroup;
  error: string;
  busy: boolean;
  message: string;
  showInputs = false;

  private email: string = '';
  private code: string = '';

  private fb = inject(UntypedFormBuilder);
  private router = inject(Router);
  private authService = inject(AuthenticationService);
  private cdr = inject(ChangeDetectorRef);

  constructor() {
    const route = inject(ActivatedRoute);

    this.createForm();

    route.queryParamMap.subscribe(
      params => {
        if (params.get('user')) {
          // an unencoded '+' in the emailed link arrives as a space; addresses can't contain spaces
          this.email = params.get('user').replace(/ /g, '+');
          this.form.controls.email.setValue(this.email);
          this.cdr.markForCheck();
        }
        if (params.get('ccode')) {
          this.code = params.get('ccode');
          this.form.controls.code.setValue(this.code);
          this.cdr.markForCheck();
        }
      });
  }

  ngOnInit(): void {

    if (this.form.valid && this.email && this.code) {
      this.confirm();
    }
  }

  async resend() {
    this.busy = true;
    this.message = 'Sending...';
    this.error = null;
    this.cdr.markForCheck();
    try {
      await this.authService.resendConfirmation(this.form.controls.email.value).then(ok => {
        if (ok) {
          // this.router.navigateByUrl('/');
        }
      }).catch(err => {

        this.error = err.message;
        this.cdr.markForCheck();

      });;
    } finally {

      this.busy = false;
      this.cdr.markForCheck();
    }
  }

  async confirm() {
    if (this.form.valid) {
      this.busy = true;
      this.message = 'Confirming...';
      this.error = null;
      this.cdr.markForCheck();

      try {
        await this.authService.confirm(this.form.controls.email.value, this.form.controls.code.value).then(ok => {

          if (ok) {
            this.router.navigate(['/signin'], { queryParams: { user: this.form.controls.email.value } });
          }
        }).catch(err => {

          this.error = err.message;

          if (err.name == 'NotAuthorizedException') {
            this.error = 'Could not confirm the specified email.  Check the email address and code.'
          } else
            if (err.name === 'CodeMismatchException') {
              this.error = 'Invalid code. Please try again.';
            } else if(err.name === 'UserNotFoundException') {
              this.error = 'User name not found or confirmation code is incorrect. Please try again.';
            }

          this.cdr.markForCheck();

        });

      } finally {
        this.busy = false;
        this.cdr.markForCheck();
      }
    }
  }

  private createForm(): void {
    this.form = this.fb.group({
      email: new UntypedFormControl(this.email, Validators.required),
      code: new UntypedFormControl(this.code, Validators.required)
    })
  }

}
